var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var UserController = /** @class */ (function () {
    function UserController() {
    }
    /*****************************************************************************************************
        * Is using route "api/user/list/{userid}/groups" and http method "GET" to call the back-end.
    
        * @param {string} userid
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    UserController.GetUserListForAllGroups = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/list/{userid}/groups", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/search" and http method "POST" to call the back-end.
    
        * @param {UserSearchDto} searchInfo
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    UserController.SearchUsers = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/search", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.searchInfo
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/list/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    UserController.GetUserListForGroup = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/list/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/onetimetoken" and http method "GET" to call the back-end.
    
        * @returns {string}
    ******************************************************************************************************/
    UserController.GetOneTimeToken = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/onetimetoken", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/list/{groupid}/excel" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @returns {LinkDto}
    ******************************************************************************************************/
    UserController.CreateUserListExcel = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/list/{groupid}/excel", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/list/{groupid}/excel/{userid}/{token}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} userid
        * @param {string} token
        * @returns {string}
    ******************************************************************************************************/
    UserController.GetUserListForGroupAsExcel = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/list/{groupid}/excel/{userid}/{token}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/settings" and http method "GET" to call the back-end.
    
        * @returns {UserSettingsDownloadDto}
    ******************************************************************************************************/
    UserController.GetUserSettings = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/settings", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/info" and http method "GET" to call the back-end.
    
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.GetUserInfo = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/info", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/info/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.GetUserInfoByUserId = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/info/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/info/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {UserUploadDto} userInfo
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.PostUserInfo = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/info/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userInfo
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/avatar/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {File} mediaData
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.PostAvatar = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaData)
            fd.append("mediaData", data.mediaData);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/avatar/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/settings/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {UserSettingsUploadDto} settings
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.PostUserSettings = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/settings/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.settings
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/stats/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserStats}
    ******************************************************************************************************/
    UserController.GetUserStats = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/stats/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/event/{name}/UserVisitedGroupEvent" and http method "POST" to call the back-end.
    
        * @param {string} name
        * @param {UserVisitedGroupEventUploadDto} eventData
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.AddUserVisitedGroupEvent = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/event/{name}/UserVisitedGroupEvent", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.eventData
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/event/{name}/UserSeenEvent" and http method "POST" to call the back-end.
    
        * @param {string} name
        * @param {UserSeenEventUploadDto} eventData
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.AddUserSeenEvent = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/event/{name}/UserSeenEvent", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.eventData
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/event/{name}/ChatEvent" and http method "POST" to call the back-end.
    
        * @param {string} name
        * @param {ChatEventUploadDto} eventData
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.AddChatEvent = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/event/{name}/ChatEvent", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.eventData
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/profile/{id?}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserProfileDownloadDto}
    ******************************************************************************************************/
    UserController.GetProfile = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/profile/{id?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/profile/{id?}" and http method "PATCH" to call the back-end.
    
        * @param {UserProfileUploadDto} profile
        * @param {File} image
        * @param {string} id
        * @returns {UserProfileDownloadDto}
    ******************************************************************************************************/
    UserController.PatchProfile = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("profile", JSON.stringify(data.profile));
        if (data.image)
            fd.append("image", data.image);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/profile/{id?}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/{groupid}/{role}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {string} role
        * @param {UserUploadDto} user
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.Post = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/{groupid}/{role}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.user
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/easy/register/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {EasyRegisterDto} data
        * @returns {string}
    ******************************************************************************************************/
    UserController.EasyRegister = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/easy/register/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.data
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/easy/join/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    UserController.EasyJoin = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/easy/join/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/{userId}/lock" and http method "POST" to call the back-end.
    Sets the locked status for a user.
    
        * @param {string} userId  The id of the user
        * @param {boolean} locked  The locked status
        * @returns {void}
    ******************************************************************************************************/
    UserController.SetUserLocked = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/{userId}/lock", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.locked
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/useradmin" and http method "GET" to call the back-end.
    Returns a list of user admins of the user except global admins.
    
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    UserController.GetUserAdmins = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/useradmin", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/excel/check/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {File} excelFile
        * @returns {ImportCheckResult<UserImportInfo>}
    ******************************************************************************************************/
    UserController.CheckExcelInvite = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/excel/check/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/excel/invite/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {OptionalTime} time
        * @param {File} excelFile
        * @returns {UserDownloadDto[]}
    ******************************************************************************************************/
    UserController.ExcelInvite = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("time", JSON.stringify(data.time));
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/excel/invite/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/newRandomPassword/{userId}" and http method "POST" to call the back-end.
    
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    UserController.SetNewRandomPassword = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/newRandomPassword/{userId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/requestRegister" and http method "POST" to call the back-end.
    
        * @param {RegisterRequestUploadDto} registerRequest
        * @returns {void}
    ******************************************************************************************************/
    UserController.RequestRegister = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/requestRegister", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.registerRequest
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/confirmRegisterRequest/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {RegisterRequestResultDto}
    ******************************************************************************************************/
    UserController.ConfirmRegisterRequest = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/confirmRegisterRequest/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/approveRegisterRequest/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    UserController.ApproveRegisterRequest = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/approveRegisterRequest/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/setPasswordFromRegisterRequest/{id}/{change}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} change
        * @returns {RegisterRequestResultDto}
    ******************************************************************************************************/
    UserController.SetPasswordFromRegisterRequest = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/setPasswordFromRegisterRequest/{id}/{change}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/{groupId}/registerRequest" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {RegisterRequestDownloadDto[]}
    ******************************************************************************************************/
    UserController.GetRegisterRequests = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/{groupId}/registerRequest", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/registerRequest/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    UserController.DeleteRegisterRequest = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/registerRequest/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/device/register" and http method "POST" to call the back-end.
    
        * @param {ApplicationType} applicationType
        * @param {DeviceType} deviceType
        * @param {string} tag
        * @returns {void}
    ******************************************************************************************************/
    UserController.RegisterDevice = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("applicationType", JSON.stringify(data.applicationType));
        fd.append("deviceType", JSON.stringify(data.deviceType));
        fd.append("tag", JSON.stringify(data.tag));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/device/register", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/push/publickey" and http method "GET" to call the back-end.
    
        * @returns {PublicKeyDownloadDto}
    ******************************************************************************************************/
    UserController.GetPublicKey = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/push/publickey", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/push/register" and http method "POST" to call the back-end.
    
        * @param {string} publicKeyId
        * @param {PushData} pushData
        * @param {ApplicationType} applicationType
        * @returns {void}
    ******************************************************************************************************/
    UserController.PostPush = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("publicKeyId", JSON.stringify(data.publicKeyId));
        fd.append("pushData", JSON.stringify(data.pushData));
        fd.append("applicationType", JSON.stringify(data.applicationType));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/push/register", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/device/unregister" and http method "POST" to call the back-end.
    
        * @param {ApplicationType} applicationType
        * @param {string} tag
        * @returns {void}
    ******************************************************************************************************/
    UserController.UnRegisterDevice = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("applicationType", JSON.stringify(data.applicationType));
        fd.append("tag", JSON.stringify(data.tag));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/device/unregister", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/device/background" and http method "POST" to call the back-end.
    
        * @param {boolean} inBackground
        * @param {ApplicationType} applicationType
        * @param {string} tag
        * @returns {void}
    ******************************************************************************************************/
    UserController.SetDeviceIsInBackground = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("inBackground", JSON.stringify(data.inBackground));
        fd.append("applicationType", JSON.stringify(data.applicationType));
        fd.append("tag", JSON.stringify(data.tag));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/device/background", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/checkAndAutoAddGroups" and http method "POST" to call the back-end.
    
        * @param {RegisterRequestConditionDto} condition
        * @returns {RegisterRequestResultDto}
    ******************************************************************************************************/
    UserController.CheckAndAutoAddGroups = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/checkAndAutoAddGroups", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.condition
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/upsertElementLastViewed/{groupId}/{element}/{time?}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} element
        * @param {number} time
        * @returns {void}
    ******************************************************************************************************/
    UserController.UpsertElementLastViewed = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/upsertElementLastViewed/{groupId}/{element}/{time?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/upsertElementLastViewedByGroupType/{groupType}/{element}/{time?}" and http method "POST" to call the back-end.
    
        * @param {string} groupType
        * @param {string} element
        * @param {number} time
        * @returns {void}
    ******************************************************************************************************/
    UserController.UpsertElementLastViewedByGroupType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/upsertElementLastViewedByGroupType/{groupType}/{element}/{time?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/getElementsLastViewed/{groupId?}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {ElementLastViewedDownloadDto[]}
    ******************************************************************************************************/
    UserController.GetElementsLastViewed = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/getElementsLastViewed/{groupId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/getElementsLastViewedByGroupType/{groupType}" and http method "GET" to call the back-end.
    
        * @param {string} groupType
        * @returns {ElementLastViewedDownloadDto[]}
    ******************************************************************************************************/
    UserController.GetElementsLastViewedByGroupType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/getElementsLastViewedByGroupType/{groupType}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/user/deactivate/{userId}" and http method "GET" to call the back-end.
    
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    UserController.DeactivateUser = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/deactivate/{userId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return UserController;
}());
export { UserController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=UserController.js.map